// BoxResultPromptPay.jsx  (React 17 + Material-UI v4, โปรเจคเก่า)
// - parity กับโค้ดใหม่ครบถ้วน แต่คงโครงสร้างโปรเจคเก่า
// - ใช้ @material-ui/core/@material-ui/icons และ import แบบ relative
// - รวม renderCoyNumberAmountContent + บล็อก transaction_uuid
// - ตัดปุ่ม "ติดต่อแอดมิน" ออกตาม requirement เดิม
// - ตัด ImageShow ออก และเปลี่ยนเป็น <img> ปกติ

import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// Redux (โปรเจคเก่า)
import { openPromotionPopup } from '../../../../../../../@core/redux/actions/promotion/index';
import { setDataAlert } from "../../../../../../../@core/redux/actions/app/alert";
import { setStatusSpinner } from "../../../../../../../@core/redux/actions/app/spinner";
import { setSnackbarData } from "../../../../../../../@core/redux/actions/app/snackbar";

// Services (โปรเจคเก่า)
// import { updatePromotionAuto } from './../../../../../../../@core/services/promotionService';

// @Utility (โปรเจคเก่า)
import copyText from './../../../../../../../@utility/app/copyText';
import { getStorage, setStorage } from '../../../../../../../@utility/app/storage';
import currencyFormat from '../../../../../../../@utility/numbers/currencyFormat';

// CSS (โปรเจคเก่า)
import styles from './../../../../assets/css/Style.module.css';
import buttonStyles from './../../../../assets/css/Button.module.css';

// Component (โปรเจคเก่า)
// import ImageShow from 'views/components/ImageShow'; // <<-- ตัดออก
import Switch from '../../component/Switch';
import BoxSlip from './BoxSlip';

// Icon (MUI v4)
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// ---------- helpers ----------
const safeOpenHref = (href) => {
    try {
        const u = new URL(href);
        return u.protocol === 'https:' || u.protocol === 'http:';
    } catch {
        return false;
    }
};

// const isIOSSafari = () => {
//     const ua = navigator.userAgent || '';
//     const isIOS = /iP(hone|od|ad)/.test(ua);
//     const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
//     return isIOS && isSafari;
// };

const isLikelyBase64Image = (raw) => {
    if (!raw) return false;
    return (
        raw.startsWith('iVBOR') || // PNG
        raw.startsWith('/9j/') ||   // JPG
        raw.startsWith('R0lGOD') || // GIF
        raw.startsWith('UklGR')     // WebP
    );
};

// ---------- main ----------
export default function BoxResultPromptPay({
    depositItems,
    reduxPromotionPopup,
    promotionItem,
    copyData,            // optional callback จาก props
    gotoPage,           // (ยังคงรับไว้แม้จะไม่ใช้ปุ่มติดต่อแอดมินแล้ว)
    typePage,
    timeDepositProcess,
    timeShow,
    channelInfo,
    openBox,
    iosPreviewUrl,
    setIosPreviewUrl,
    promotionSwitch,
    setPromotionSwitch
}) {
    const dispatch = useDispatch();

    const homeData = useSelector((s) => s.reduxHome.result);
    // บางโปรเจคเก่าจะเก็บไว้ที่ reduxAppDataSetting.result หรือ reduxAppMenu.menu_items
    const dataSetting = useSelector(state => state.reduxAppMenu.menu_items);

    // const [promotionSwitch, setPromotionSwitch] = useState(false);
    const [payMode, setPayMode] = useState('');
    const [payAccount, setPayAccount] = useState(null);
    const [paySrc, setPaySrc] = useState('');
    const [payAmount, setPayAmount] = useState(0);
    const [qrcodeIsGenBase64, setQrcodeIsGenBase64] = useState(false);
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));

    const qrRef = useRef(null);

    const showWarning = (text) => {
        dispatch(setDataAlert({
            type: "warning",
            title: "แจ้งเตือน",
            text,
            action: true,
            show: true,
            buttonText: "ตกลง"
        }));
    };

    const explodeDecimal = (decimal) => {
        const val = (decimal ?? '').toString();
        const [a = '', b = '00'] = val.split('.');
        return (
            <>
                {a}.<span style={{ color: '#FFE600' }}>{b}</span>
            </>
        );
    };

    const doCopy = (text) => {
        if (copyData) copyData(text);
        else copyText(text);

        openBox({
            statusShow: true,
            statusAlert: "success",
            titleAlert: "แจ้งเตือน",
            textAlert: "คัดลอกสำเร็จ !"
        });
    };

    const newTabUrlAkPay = () => {
        const depositPromptPayTime = getStorage('depositPromptPayTime');
        if (!depositPromptPayTime) {
            const timeStart = Date.now() + 5 * 60 * 1000;
            setStorage('depositPromptPayTime', timeStart);
        }
        if (!safeOpenHref(paySrc)) return;
        window.location.href = paySrc;
    };

    // 🛠️ New Download Logic
    const downloadQRCode = async () => {
        // 1. เช็คเงื่อนไขพื้นฐาน
        if (!timeDepositProcess || !qrRef.current) return;

        // ✅ เปิด Spinner
        dispatch(setStatusSpinner({
            status: true,
            textProcess: "กำลังบันทึก QR Code กรุณารอสักครู่...",
        }));

        let isTimeout = false;
        let generatedBase64 = null; // ต้องอยู่นอก try/catch และ timeout

        // ⏰ เริ่มจับเวลา 5 วินาที (Timeout Fallback)
        const timerId = setTimeout(() => {
            isTimeout = true;
            console.warn("Process timeout.");

            // ปิด Spinner เสมอเมื่อหมดเวลา
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (generatedBase64) {
                // ถ้ามีรูปแล้ว แต่ระบบช้า → เด้ง Popup ให้เซฟเอง
                setIosPreviewUrl(generatedBase64);
            } else {
                // ยังไม่มีรูป แสดงว่า html2canvas ค้างจริง ๆ
                if (showWarning) {
                    showWarning("การทำงานล่าช้า กรุณาลองใหม่อีกครั้ง");
                } else {
                    alert("การทำงานล่าช้า กรุณาลองใหม่อีกครั้ง");
                }
            }
        }, 5000);

        try {
            console.log("Generating QR Code image...");

            // --- Config CORS ให้รูปทั้งหมดใน container ---
            const target = qrRef.current;
            target.querySelectorAll("img").forEach((img) => {
                if (!img.src?.startsWith("data:")) {
                    img.setAttribute("crossorigin", "anonymous");
                }
            });

            // 2. เริ่มสร้าง Canvas จาก container
            const canvas = await html2canvas(target, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: Math.min(window.devicePixelRatio || 2, 2),
                logging: false,
                onclone: (doc) => {
                    doc.querySelectorAll(".qrContainer img").forEach((img) => {
                        if (!img.src?.startsWith("data:")) {
                            img.setAttribute("crossorigin", "anonymous");
                        }
                    });
                },
            });

            // ⭐️ เก็บค่ารูปภาพไว้ (base64 ใช้ได้ทั้ง popup / download)
            generatedBase64 = canvas.toDataURL("image/png", 1.0);

            // ถ้า ณ จุดนี้ timeout ไปแล้ว → แสดง popup แล้วจบเลย
            if (isTimeout) {
                console.warn("Canvas สร้างเสร็จหลัง timeout: แสดง popup จาก base64");
                setIosPreviewUrl(generatedBase64);
                return;
            }

            // 3. แปลงเป็น Blob เพื่อเตรียม Share/Download
            canvas.toBlob(async (blob) => {
                // กันเคส toBlob เสร็จหลัง timeout ทำงาน
                if (isTimeout) {
                    // ถึงจะ timeout ไปแล้ว แต่เรามี base64 อยู่: ให้ popup ช่วยผู้ใช้
                    if (generatedBase64) {
                        setIosPreviewUrl(generatedBase64);
                    }
                    return;
                }

                // ✅ ถึงจุดนี้คือ “ทันเวลา” แล้ว → เคลียร์ timer ได้
                clearTimeout(timerId);

                if (!blob) {
                    // สร้าง blob ไม่สำเร็จ → ปิด spinner + fallback จาก base64 / warning
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));

                    console.error("Blob generation failed");
                    if (generatedBase64) {
                        setIosPreviewUrl(generatedBase64);
                    } else if (showWarning) {
                        showWarning("ไม่สามารถสร้างไฟล์รูปภาพได้ กรุณาลองใหม่อีกครั้ง");
                    } else {
                        alert("ไม่สามารถสร้างไฟล์รูปภาพได้ กรุณาลองใหม่อีกครั้ง");
                    }
                    return;
                }

                const timestamp = Date.now();
                const accountNo = depositItems?.customer_bank_account || "qr";
                const fileName = `payment-${accountNo}-${timestamp}.png`;
                const file = new File([blob], fileName, { type: "image/png" });
                const ua = navigator.userAgent;
                const isMobile = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);

                // Chrome บน iOS (CriOS)
                const isChromeIOS = /CriOS/i.test(ua) && /iPhone|iPod|iPad/i.test(ua);

                // Apple Devices (iOS / iPadOS / macOS)
                const isApple = /iPhone|iPad|iPod|Macintosh|Mac OS X/i.test(ua);
                const canShare = navigator.canShare && navigator.canShare({ files: [file] });

                // -------------------------------------------------
                // 📱 Mobile (Android/iOS ที่รองรับ Web Share + File)
                // -------------------------------------------------
                if (isApple || isChromeIOS) {
                    // ปิด Spinner ก่อนเรียก Share Sheet
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));

                    if (canShare) {
                        try {
                            await navigator.share({
                                files: [file],
                                title: "QR Code สำหรับจ่ายเงิน",
                                text: "กรุณาสแกนเพื่อชำระเงิน",
                            });

                            dispatch(setSnackbarData({
                                statusShow: true,
                                statusAlert: "success",
                                titleAlert: "แจ้งเตือน",
                                textAlert: "บันทึกรูปภาพสำเร็จ!"
                            }));
                        } catch (shareErr) {
                            console.error("Share failed:", shareErr);
                            // ถ้า Share พัง → เด้ง Popup รูปภาพแทน
                            setIosPreviewUrl(generatedBase64);
                        }
                    }
                    else {
                        setIosPreviewUrl(generatedBase64);
                    }
                }
                else if (isMobile) {
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));

                    try {
                        const a = document.createElement("a");
                        a.href = generatedBase64; // ใช้ base64 ที่สร้างไว้
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);

                        dispatch(setSnackbarData({
                            statusShow: true,
                            statusAlert: "success",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "บันทึกรูปภาพสำเร็จ!"
                        }));
                    } catch (error) {
                        console.error("Download failed:", error);
                        // ถ้า Share พัง → เด้ง Popup รูปภาพแทน
                        setIosPreviewUrl(generatedBase64);
                    }
                }
                // -------------------------------------------------
                // 💻 Desktop หรือ Mobile ที่แชร์ไฟล์ไม่ได้
                // -------------------------------------------------
                else {
                    // ปิด Spinner
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));

                    if (isMobile || isApple || isChromeIOS) {
                        // 📱 Mobile แต่ share ไม่ได้ (เช่น บราวเซอร์ไม่รองรับ / iOS บางตัว)
                        setIosPreviewUrl(generatedBase64);
                    } else {
                        // 💻 Desktop → ดาวน์โหลดไฟล์อัตโนมัติ
                        const a = document.createElement("a");
                        a.href = generatedBase64; // ใช้ base64 ที่สร้างไว้
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);

                        dispatch(setSnackbarData({
                            statusShow: true,
                            statusAlert: "success",
                            titleAlert: "แจ้งเตือน",
                            textAlert: "บันทึกรูปภาพสำเร็จ!"
                        }));
                    }
                }
            }, "image/png");
        } catch (err) {
            console.error("Error generating QR:", err);
            clearTimeout(timerId); // กันเคสยังไม่ timeout แต่เข้า catch ก่อน
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            // ถ้ามีรูปแล้ว → เด้ง popup ให้เซฟเอง
            if (generatedBase64) {
                setIosPreviewUrl(generatedBase64);
            } else if (showWarning) {
                showWarning("ไม่สามารถบันทึก QR Code ได้ กรุณาแคปหน้าจอแทน");
            } else {
                alert("ไม่สามารถบันทึก QR Code ได้ กรุณาแคปหน้าจอแทน");
            }
        }
    };

    const readIconBank = (keyword, eventSelect) => {
        const kw = (typeof keyword === 'string' ? keyword : '').toLowerCase();
        const banks = dataSetting?.agent_setting_bank || [];

        const result = banks.find((bank) => {
            const short = bank?.bank_short?.toLowerCase?.() || '';
            const swift = bank?.bank_switfcode?.toLowerCase?.() || '';
            return short.includes(kw) || swift.includes(kw);
        });

        if (eventSelect === 'name') return result?.bank_name || keyword || '-';
        if (eventSelect === 'image') return result?.bank_img || channelInfo?.picture || '/images/bank-none.png';
        return '';
    };

    // ---------- parity: amount block ----------
    const renderCoyNumberAmountContent = () => (
        <div className="boxDetailQRCodeScanNumberTransfer">
            <Grid container alignItems="center" justify="space-between" spacing={1}>
                <Grid item xs={3} md={3}>ยอดโอน :</Grid>
                <Grid item xs={6} md={6}>
                    <div className="boxDetailQRCodeScanNumberTransferTitle textBold center">
                        {(() => {
                            const formatted = currencyFormat(payAmount, 2);
                            const [intPart, decPart] = formatted.split('.');
                            return (
                                <>
                                    <span>{intPart}</span>
                                    {decPart !== undefined && <span style={{ color: 'var(--bt-danger)' }}>.{decPart}</span>} {' '}
                                    บาท
                                </>
                            );
                        })()}
                    </div>
                </Grid>
                <Grid item xs={3} md={3} className="right">
                    <button
                        type="button"
                        className={`boxDetailQRCodeScanNumberTransferCopy ${!timeDepositProcess ? '' : 'btnHover'}`}
                        style={{ opacity: !timeDepositProcess ? '0.5' : 1 }}
                        disabled={!timeDepositProcess}
                        onClick={() => timeDepositProcess && doCopy(currencyFormat(payAmount, 2))}
                    >
                        <Grid container alignItems="center" justify="center" spacing={1}>
                            <Grid item xs={3}><ContentCopyIcon className="iconTransactionaction iconTransactionactionRe" /></Grid>
                            <Grid item xs={9}>คัดลอก</Grid>
                        </Grid>
                    </button>
                </Grid>
            </Grid>
        </div>
    );

    // ---------- iframe / link-tab ----------
    const renderContentIframe = () => {
        if (!paySrc) return null;

        if (payMode === 'iframe' && safeOpenHref(paySrc)) {
            return (
                <div className={styles.boxDetailTop}>
                    <iframe
                        title="iframe"
                        className={styles.qrCodePromptPay}
                        src={paySrc}
                        scrolling="no"
                        frameBorder="0"
                    />
                </div>
            );
        }

        if (payMode === 'link-tab') {
            return (
                <>
                    {channelInfo?.event_select === 'number' && (
                        <div className={styles.boxDetailTop} style={{ borderBottom: '2px dashed #000000' }}>
                            <div className={styles.boxAccountAgentTitle}>จำนวนเงินที่ต้องโอน</div>
                            <div className={styles.boxMarginTop}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={5}>ยอดทั้งหมด</Grid>
                                    <Grid item xs={5}>
                                        <div className={`${styles.boxDetailAmountNumber} ${styles.boxDetailAmountNumberText}`}>
                                            {explodeDecimal(currencyFormat(depositItems?.amount, 2))}
                                        </div>
                                    </Grid>
                                    <Grid item xs={2}>บาท</Grid>
                                </Grid>
                            </div>
                            <div className={[styles.boxMarginTop, 'center'].join(' ')}>
                                <div className={styles.bankPromotionComment}>
                                    ** กรุณาใช้บัญชี <span style={{ fontWeight: 'bold' }}>"{depositItems?.customer_bank_account} - {depositItems?.customer_bank_account_name}"</span> โอนเงินมาเท่านั้น **
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={styles.boxDetailTop}>
                        <div className="center">
                            {timeDepositProcess && (
                                <button
                                    className={[buttonStyles.btnRedirect, buttonStyles.btnConfirm].join(' ')}
                                    onClick={newTabUrlAkPay}
                                >
                                    ดูบัญชีโอนเงิน {timeShow !== 0 ? `(${timeShow})` : ''}
                                </button>
                            )}
                        </div>

                        <div className={[styles.boxMarginTop, 'center'].join(' ')}>
                            {timeDepositProcess ? (
                                <div className={styles.bankPromotionComment}>
                                    ** กรุณากดที่ปุ่ม "ดูบัญชีโอนเงิน" เพื่อโอนเงินเข้าระบบ **
                                </div>
                            ) : (
                                <div className={styles.bankPromotionComment}>
                                    ** หมดเวลาทำรายการ **
                                </div>
                            )}
                        </div>
                    </div>
                </>
            );
        }

        return null;
    };

    // ---------- qrcode / account / bank ----------
    const renderContentNoIframe = () => {
        if (payMode === 'qrcode' && paySrc) {
            return (
                <>
                    <div className="contentBoxMarginTop center" style={{ marginTop: !isLargeScreen ? "-10px" : 0 }}>
                        <ArrowDownwardIcon className="transactionIconArrowDown" />
                    </div>

                    {
                        (typePage !== 'bank' && homeData?.promotion_auto === 1) && (
                            <div style={{ marginBottom: "15px" }}>
                                <div className="depositPromotionAutoCard">
                                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                                        <Grid item>
                                            <CheckCircleIcon className="depositPromotionAutoCardIcon" />
                                        </Grid>
                                        <Grid item>
                                            คุณได้รับเลือกโปรโมชั่นอัตโนมัติ
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        )
                    }

                    <div className={styles.boxDetailTop}>
                        <div className="boxDetailAmountQrcodeNumber center" style={{ marginTop: '0px' }}>
                            กรุณาโอนภายใน :{' '}
                            <span className="boxDetailAmountQrcodeNumberText">
                                {timeShow === 'expired' ? 'หมดเวลา' : (timeShow || '00:00')}
                            </span>
                        </div>

                        <div className="boxDetailQRCode center">
                            <div>
                                <div className="boxDetailQRCodeScan" ref={qrRef}>
                                    <div className="boxDetailQRCodeBG">
                                        <img src="/images/ci-qrpayment-img-01.png" className="iconPromtpaySize" alt="PromptPay" />
                                    </div>

                                    <div className="boxDetailQRCodeGenTop">
                                        {!timeDepositProcess && (
                                            <div className="boxDetailQRCodeScanNote03" style={{ paddingTop: '0px' }}>
                                                คิวอาร์โค้ดหมดอายุ
                                            </div>
                                        )}

                                        {timeDepositProcess && (
                                            <div className="boxDetailQRCodeScanNote02" style={{ paddingTop: '0px' }}>
                                                ** ใช้ทำรายการได้เพียงครั้งเดียวเท่านั้น **
                                            </div>
                                        )}

                                        <br />
                                        <div style={{ opacity: !timeDepositProcess ? '.5' : '1' }}>
                                            {(!paySrc || paySrc === 'expired') && <QRCodeCanvas value="expired" size={200} />}

                                            {(paySrc && paySrc !== 'expired') &&
                                                (!qrcodeIsGenBase64 ? (
                                                    <QRCodeCanvas value={paySrc} size={200} />
                                                ) : (
                                                    <img className="iconPromtpayBase64" src={`data:image/png;base64,${paySrc}`} alt="QR Base64" />
                                                ))}
                                        </div>

                                        {timeDepositProcess ? (
                                            depositItems?.transaction_uuid ? (
                                                <>
                                                    <div className="boxDetailQRCodeScanNote03 boxDetailQRCodeScanNote022 qrTextUUID" style={{ color: 'var(--bt-undefult)' }}>
                                                        {depositItems?.transaction_uuid}
                                                    </div>
                                                    <br />
                                                </>
                                            ) : null
                                        ) : (
                                            <>
                                                <div className="boxDetailQRCodeScanNote03" style={{ paddingTop: '20px' }}>
                                                    ** กรุณาสร้างรายการใหม่อีกครั้ง **
                                                </div>
                                                <br />
                                            </>
                                        )}
                                    </div>

                                    <div className="boxDetailQRCodeBGSupport">
                                        ทางเข้าเล่น {window.location.hostname}
                                    </div>
                                </div>
                            </div>

                            <div className="boxDetailQRCodeButtonSave center">
                                <button
                                    className={[buttonStyles.btnConfirm, buttonStyles.btnRegister].join(' ')}
                                    onClick={downloadQRCode}
                                    disabled={!timeDepositProcess}
                                    style={{ opacity: timeDepositProcess ? 1 : 0.5 }}
                                >
                                    ดาวน์โหลด QR Code
                                </button>
                            </div>
                        </div>

                        <div className="transactionProcessText02 center">
                            กรุณาเเคปหน้าจอเพื่อนำไปใช้สเเกน หรือดาวน์โหลด QR Code
                        </div>

                        {/* พร้อมเพย์ + คัดลอก */}
                        {/* {payAccount?.account && (
                            <>
                                <div className="contentMarginTop02 transactionProcessText03 center">
                                    <span style={{ color: "var(--bt-danger)" }}>**</span>สามารถคัดลอกเลขพร้อมเพย์เพื่อโอนเงิน<span style={{ color: "var(--bt-danger)" }}>**</span>
                                </div>
                                <div className="boxDetailQRCodeScanNumberTransfer contentMarginTop02">
                                    <Grid container alignItems="center" justify="space-between" spacing={1}>
                                        <Grid item xs={3} md={3}>เลขพร้อมเพย์ :</Grid>
                                        <Grid item xs={6} md={6}>
                                            <div className="boxDetailQRCodeScanNumberTransferTitle textBold center" style={{ color: 'var(--bt-danger)' }}>
                                                {payAccount?.account}
                                            </div>
                                        </Grid>
                                        <Grid item xs={3} md={3} className="right">
                                            <button
                                                type="button"
                                                className={`boxDetailQRCodeScanNumberTransferCopy ${!timeDepositProcess ? '' : 'btnHover'}`}
                                                style={{ opacity: !timeDepositProcess ? '0.5' : 1 }}
                                                disabled={!timeDepositProcess}
                                                onClick={() => timeDepositProcess && doCopy(payAccount?.account)}
                                            >
                                                <Grid container alignItems="center" justify="center" spacing={1}>
                                                    <Grid item xs={3}><ContentCopyIcon className="iconTransactionaction iconTransactionactionRe" /></Grid>
                                                    <Grid item xs={9}>คัดลอก</Grid>
                                                </Grid>
                                            </button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </>
                        )} */}

                        {channelInfo?.event_select === 'number' && (
                            <div className="contentMarginTop02">
                                {
                                    renderCoyNumberAmountContent()
                                }
                            </div>
                        )}

                        {depositItems?.transaction_uuid && (
                            <div className="contentMarginTop02">
                                <div className="boxDetailQRCodeScanNumberTransfer boxDetailQRCodeScanNumberTransferRe left">
                                    <Grid container alignItems="center" justify="space-between" spacing={1}>
                                        <Grid item xs={3} md={3}>เลขอ้างอิง :</Grid>
                                        <Grid item xs={6} md={6}>
                                            <div className="textSingleLine boxDetailQRCodeScanRefer center">
                                                {depositItems?.transaction_uuid}
                                            </div>
                                        </Grid>
                                        <Grid item xs={3} md={3} className="right">
                                            <button
                                                type="button"
                                                className="boxDetailQRCodeScanNumberTransferCopy btnHover"
                                                style={{ opacity: 1 }}
                                                onClick={() => doCopy(depositItems?.transaction_uuid)}
                                            >
                                                <Grid container alignItems="center" justify="center" spacing={1}>
                                                    <Grid item xs={3}><ContentCopyIcon className="iconTransactionaction iconTransactionactionRe" /></Grid>
                                                    <Grid item xs={9}>คัดลอก</Grid>
                                                </Grid>
                                            </button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            );
        }

        if ((payMode === 'account' && payAccount) || payMode === 'bank') {
            return (
                <>
                    <div className="contentBoxMarginTop center">
                        <ArrowDownwardIcon className="transactionIconArrowDown" />
                    </div>

                    {
                        (typePage !== 'bank' && homeData?.promotion_auto === 1) && (
                            <div style={{ marginBottom: "15px" }}>
                                <div className="depositPromotionAutoCard">
                                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                                        <Grid item>
                                            <CheckCircleIcon className="depositPromotionAutoCardIcon" />
                                        </Grid>
                                        <Grid item>
                                            คุณได้รับเลือกโปรโมชั่นอัตโนมัติ
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        )
                    }

                    <div className={styles.boxDetailTop}>
                        <div className={styles.boxAccountAgentTitle}>โอนเงินมาที่บัญชี</div>
                        <div className={[styles.boxDetailAmount, styles.boxDetailAgent].join(' ')} style={{ marginTop: '0px' }}>
                            <Grid container alignItems="center" spacing={3}>
                                <Grid item xs={2}>
                                    {
                                        payMode === 'bank' ?
                                            <img
                                                className="transactionBankIcon"
                                                src={depositItems?.agent_bankimg}
                                                style={{ width: '100%', borderRadius: 6 }}
                                                alt=""
                                            />
                                            :
                                            <img
                                                className="transactionBankIcon"
                                                src={readIconBank(payAccount?.code, 'image')}
                                                style={{ width: '100%', borderRadius: 6 }}
                                                alt=""
                                            />
                                    }
                                </Grid>
                                <Grid item xs={10}>
                                    {payMode === 'bank' ? (
                                        <div className={styles.boxAccountAgentText} style={{ fontWeight: 500 }}>
                                            {depositItems?.agent_bankname}
                                            <br />
                                            ชื่อบัญชี  : {depositItems?.agent_bank_account_name}
                                            <br />
                                            เลขบัญชี : {depositItems?.agent_bank_account}
                                        </div>
                                    ) : (
                                        <div className={styles.boxAccountAgentText} style={{ fontWeight: 500 }}>
                                            {readIconBank(payAccount?.code, 'name')}
                                            <br />
                                            ชื่อบัญชี  : {payAccount?.name}
                                            <br />
                                            เลขบัญชี : {payAccount?.account}
                                        </div>
                                    )}
                                </Grid>
                            </Grid>

                            <>
                                <br />
                                <div className="center" style={{ opacity: timeDepositProcess ? "1" : "0.5" }}>
                                    <button
                                        className={[buttonStyles.btnConfirm, buttonStyles.btnCopy].join(' ')}
                                        onClick={() => timeDepositProcess && doCopy(payMode === 'bank' ? depositItems?.agent_bank_account : payAccount?.account)}
                                    >
                                        คัดลอกเลขบัญชี
                                    </button>
                                </div>

                                {timeDepositProcess && (
                                    <>
                                        {channelInfo?.event_select === 'auto' && (
                                            <div className={[styles.boxMarginTop, 'center'].join(' ')}>
                                                <div className={styles.bankPromotionComment}>
                                                    ** กรุณาใช้บัญชี <span style={{ fontWeight: 'bold' }}>"{depositItems?.customer_bank_account} - {depositItems?.customer_bank_account_name}"</span> โอนเงินมาเท่านั้น **
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        </div>
                    </div>

                    {channelInfo?.event_select === 'number' && (
                        <div className={`${styles.boxDetailTop} ${styles.boxMarginTop}`}>
                            <div className="boxDetailAmountQrcodeNumber center" style={{ marginTop: '0px' }}>
                                กรุณาโอนภายใน :{' '}
                                <span className="boxDetailAmountQrcodeNumberText">
                                    {timeShow === 'expired' ? 'หมดเวลา' : (timeShow || '00:00')}
                                </span>
                            </div>

                            <div className="contentMarginTop02">
                                {renderCoyNumberAmountContent()}
                            </div>

                            {depositItems?.transaction_uuid && (
                                <div className="contentMarginTop02">
                                    <div className="boxDetailQRCodeScanNumberTransfer boxDetailQRCodeScanNumberTransferRe left">
                                        <Grid container alignItems="center" justify="space-between" spacing={1}>
                                            <Grid item xs={4} md={3}>เลขอ้างอิง :</Grid>
                                            <Grid item xs={5} md={6}>
                                                <div className="textSingleLine boxDetailQRCodeScanRefer center">
                                                    {depositItems?.transaction_uuid}
                                                </div>
                                            </Grid>
                                            <Grid item xs={3} md={3} className="right">
                                                <button
                                                    type="button"
                                                    className="boxDetailQRCodeScanNumberTransferCopy btnHover"
                                                    style={{ opacity: 1 }}
                                                    onClick={() => doCopy(depositItems?.transaction_uuid)}
                                                >
                                                    <Grid container alignItems="center" justify="center" spacing={1}>
                                                        <Grid item xs={3}><ContentCopyIcon className="iconTransactionaction iconTransactionactionRe" /></Grid>
                                                        <Grid item xs={9}>คัดลอก</Grid>
                                                    </Grid>
                                                </button>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            )}

                            <div className="center contentMarginTop02">
                                <div className="bankPromotionComment" style={{ color: 'var(--bg-black)' }}>
                                    กรุณาโอนจากบัญชีที่ผูกไว้เท่านั้น ไม่เช่นนั้นจะไม่สามารถทำรายการได้
                                </div>
                            </div>
                        </div>
                    )}
                </>
            );
        }

        return null;
    };

    const renderContent = () => {
        if ((payMode === 'iframe' || payMode === 'link-tab') && paySrc) return renderContentIframe();
        if (((payMode === 'account' || payMode === 'qrcode') && (paySrc || payAccount)) || payMode === 'bank') {
            return renderContentNoIframe();
        }
        return null;
    };

    // ---------- effects ----------
    useEffect(() => {
        if (depositItems?.mode === 'pay') {
            const paySrcData = getStorage('paySrc');
            setQrcodeIsGenBase64(isLikelyBase64Image(paySrcData));

            setPayMode(getStorage('payMode') || '');
            setPaySrc(timeDepositProcess ? (getStorage('paySrc') || '') : 'expired');

            try {
                const raw = getStorage('payAccount');
                setPayAccount(raw ? JSON.parse(raw) : null);
            } catch {
                setPayAccount(null);
            }

            const readPayAmount = getStorage('payAmount');
            if (readPayAmount && !isNaN(Number(readPayAmount))) {
                setPayAmount(Number(readPayAmount));
            } else {
                setPayAmount(Number(depositItems?.amount || 0));
            }
        }
    }, [depositItems, timeDepositProcess]);

    useEffect(() => {
        if (homeData !== null) {
            setPromotionSwitch(homeData?.promotion_auto === 1);
        }
    }, [homeData]);

    // useEffect(() => {
    //     if (promotionSwitch !== null) {
    //         const promotion_auto = promotionSwitch ? 1 : 0;
    //         // โปรเจคเก่ามี service updatePromotionAuto แยก
    //         updatePromotionAuto(promotion_auto).then(() => { });
    //     }
    // }, [promotionSwitch]);

    const openPromotion = (data) => {
        dispatch(openPromotionPopup({
            tab: 'promotionPopup',
            show: true,
            promotionId: data.id,
            promotionData: data
        }));
    };

    // const clickPromotionAutoSwitch = (promotionStatus) => {
    //     const promotion_auto = promotionStatus ? 1 : 0;
    //     setPromotionSwitch(promotionStatus);
    //     updatePromotionAuto(promotion_auto).then(() => { });
    // };

    return (
        <>
            {renderContent()}

            {/* แสดงสลิปเมื่ออยู่โหมด pay */}
            {depositItems?.mode === 'pay' && (
                <div className={styles.boxMarginTop}>
                    <BoxSlip depositItems={depositItems} />
                </div>
            )}

            {/* โปรโมชัน: หน้า bank */}
            {typePage === 'bank' && (
                <div className={styles.boxMarginTop}>
                    <div className={styles.boxDetailTop}>
                        <Grid container alignItems="center" justify="space-between" spacing={2}>
                            <Grid item>
                                <div className={styles.boxAccountAgentTitle + ' textBoldHight'}>
                                    {promotionSwitch ? 'รับโปรโมชั่น' : 'ไม่รับโปรโมชั่น'}
                                </div>
                            </Grid>
                            <Grid item>
                                <Switch
                                    isOn={promotionSwitch}
                                    onColor="#38C172"
                                    handleToggle={() => setPromotionSwitch(!promotionSwitch)}
                                />
                            </Grid>
                        </Grid>

                        {promotionSwitch && (
                            (homeData?.balance ?? 0) <= (Number(process.env.REACT_APP_BALANCE_LIMIT) || 0) ? (
                                <>
                                    <div className={styles.boxMarginTop}>
                                        <div className="boxAccountAgentSub">
                                            โปรโมชั่นเเนะนำสำหรับคุณ (กรุณากดเลือกรับโปรโมชั่น)
                                        </div>
                                    </div>

                                    <div className="boxMarginTop">
                                        {promotionItem && (
                                            promotionItem.length > 0 ? (
                                                <div className="menuPositionWidthScroll" style={{ marginLeft: '0px', marginRight: '0px', paddingBottom: '10px' }}>
                                                    <div className="flexContent">
                                                        {promotionItem.map((item) => {
                                                            const isSelected = reduxPromotionPopup?.promotionSelect && reduxPromotionPopup?.promotionId === item.id;
                                                            return (
                                                                <div key={item.id} className="positionRelative" onClick={() => openPromotion(item)}>
                                                                    <img
                                                                        className={isSelected ? 'transactionImgPromotionListBorder' : 'transactionImgPromotionList'}
                                                                        src={item.content_picture}
                                                                        alt="promotion"
                                                                    />
                                                                    <div className="btnActionPosition">
                                                                        <div className={isSelected ? 'btn btnCancelPromotion btnFilter btnHover btnWidthFull btnRadius' : 'btn btnSelectPromotion btnFilter btnHover btnWidthFull btnRadius'}>
                                                                            {isSelected ? 'ยกเลิกรับโปรโมชั่น' : 'เลือกรับโปรโมชั่น'}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="center">
                                                    <img className="transactionImgPromotionNone" src="/images/game/promotion_none.webp" alt="promotion none" />
                                                    <br /><br />
                                                </div>
                                            )
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="boxMarginTop">
                                    <div className="bankPromotionComment">
                                        ไม่สามารถเลือกโปรโมชั่นได้ เนื่องจากเครดิตของคุณมีมากกว่า {process.env.REACT_APP_BALANCE_LIMIT} เครดิต
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}

            {/* โปรโมชัน: หน้าอื่น (สวิตช์อัตโนมัติ) */}
            {/* {typePage !== 'bank' && (
                <div className={styles.boxMarginTop}>
                    <div className={styles.boxDetailTop}>
                        <Grid container alignItems="center" justify="space-between" spacing={2}>
                            <Grid item>
                                <div className={styles.boxAccountAgentTitle}>
                                    เลือกรับโปรโมชั่นอัตโนมัติ
                                </div>
                            </Grid>
                            <Grid item>
                                <Switch
                                    isOn={promotionSwitch}
                                    onColor="#38C172"
                                    handleToggle={() => clickPromotionAutoSwitch(!promotionSwitch)}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )} */}
        </>
    );
}
